import { Fun } from 'widgets-for-react'

import { CtaBlockStyle } from '../../cms/blocks/widgets/ctaBlock.gen'
import { DownloadBlockStyle } from '../../cms/blocks/widgets/downloadBlock.gen'
import { ExpandBlockStyle } from '../../cms/blocks/widgets/expandBlock.gen'
import { FeaturedContentBlockStyle } from '../../cms/blocks/widgets/featuredContentBlock.gen'
import { IframeBlockStyle } from '../../cms/blocks/widgets/iframeBlock.gen'
import { LinkBlockStyle } from '../../cms/blocks/widgets/linkBlock.gen'
import { LinkGridBlockStyle } from '../../cms/blocks/widgets/linkGridBlock.gen'
import { MediaBlockStyle } from '../../cms/blocks/widgets/mediaBlock.gen'
import { TextBlockStyle } from '../../cms/blocks/widgets/textBlock.gen'
import { BSLCaseSliderBlockStyle } from './custom_blocks/widgets/bsl_case_slider'
import { BSLBeslismatrixFormBlockStyle } from './custom_blocks/widgets/bsl_beslismatrix_form'
import { BSLContactPersonBlockStyle } from './custom_blocks/widgets/bsl_contact_person'
import { BSLCountersBlockStyle } from './custom_blocks/widgets/bsl_counters_block'
import { BSLEventOverviewBlockStyle } from './custom_blocks/widgets/bsl_event_overview'
import { BSLArticleHighlightBlockStyle }from './custom_blocks/widgets/bsl_article_highlight'
import { BSLFeaturedContentBlockStyle } from './custom_blocks/widgets/bsl_featured_content_block'
import { BSLHeaderBlockStyle } from './custom_blocks/widgets/bsl_header'
import { BSLLatestEventsBlockStyle } from './custom_blocks/widgets/bsl_latest_events'
import { BSLLatestVacanciesBlockStyle } from './custom_blocks/widgets/bsl_latest_vacancies'
import { BSLQuoteBlockStyle } from './custom_blocks/widgets/bsl_quote_block'
import { BSLRichMediaBlockStyle } from './custom_blocks/widgets/bsl_richmedia_block'
import { BSLShowcaseBlockStyle } from './custom_blocks/widgets/bsl_showcase'
import { BSLSuperGridBlockStyle } from './custom_blocks/widgets/bsl_super_grid'
import { BSLTabsBlockStyle } from './custom_blocks/widgets/bsl_tabs'
import { BSLVacancySliderBlockStyle } from './custom_blocks/widgets/bsl_vacancy_slider'

export const featuredContentClasses: Fun<'left' | 'right', FeaturedContentBlockStyle> = m => ({})

export const textBlockClasses: TextBlockStyle = {
  block_classname: 'block block--small',
  title_classname: 'title--l',
  content_classname: 'text--styled',
  footer_classname: 'buttons buttons--mt',
  clickable_primary_classname: 'button--primary',
  clickable_secondary_classname: 'button--secondary'
}

export const linkGridBlockClasses: Fun<number, LinkGridBlockStyle> = amountOfItems => ({
  block_classname: 'block block--grid',
  header_classname: 'grid__header',
  title_classname: 'title--l title--mb2',
  intro_classname: 'intro',
  list_classname: `flex flex--${amountOfItems} grid`,
  grid_item_classname: 'flex-item grid-item',
  grid_title_classname: 'title--xs grid-item__title',
  grid_link_classname: 'grid-item__link',
  grid_content_classname: 'grid-item__content',
  grid_visual_classname: 'grid-item__figure',
  grid_image_classname: 'grid-item__image'
})

export const linkGridBlockPlainClasses: Fun<number, LinkGridBlockStyle> = n => ({
  block_classname: 'block',
  title_classname: 'title--l'
})

export const expandBlockClasses: ExpandBlockStyle = {
  block_classname: 'block',
  title_classname: 'title--l',
  inner_classname: 'expandables__inner',
  header_classname: 'expandables__header',
  content_classname: 'expand__content',
  expand_item_classname: 'expand-item',
  expand_text_classname: 'expand-item__body text--styled',
  expand_button_classname: 'expand-item__button',
  expand_title_classname: 'expand-item__title',
  expand_icon_classname: 'expand-item__icon',
  footer_classname: 'expand__footer',
  clickable_classname: 'button--secondary'
}

export const ctaBlockClasses: CtaBlockStyle = {}

export const linkListBlockClasses: LinkBlockStyle = {
  block_classname: 'block block--grey-left',
  title_classname: 'title--l',
  list_classname: 'columns',
  item_classname: 'column',
  link_classname: 'link-block'
}

export const downloadBlockClasses: DownloadBlockStyle = {}

export const bslHeaderBlockClasses: BSLHeaderBlockStyle = {}

export const bslRichMediaBlockClasses: BSLRichMediaBlockStyle = {}

export const mediaBlockClasses: Fun<'image' | 'video', MediaBlockStyle> = k => ({
  block_classname: 'block block--small',
  video_classname: 'media__video',
  image_classname: 'media__image',
  caption_classname: 'caption',
  cookies_classname: 'cookie-notice block',
  cookies_inner_classname: 'text--styled',
  cookies_clickable_classname: 'button--secondary'
})

export const bslQuoteBlockClasses: BSLQuoteBlockStyle = {
  block_classname: 'block block--small',
  title_classname: 'title--xs',
  footer_classname: 'quote__footer',
  footer_inner_classname: 'quote_footer-inner',
  figure_classname: 'quote__figure',
  clickable_classname: 'link'
}

export const bslFeaturedContentBlockClasses: Fun<'left' | 'right', BSLFeaturedContentBlockStyle> = imageLocation => ({
  block_classname: `block block--featured block--grey-${imageLocation === 'left' ? 'right' : 'left'}`,
  title_classname: 'title--l',
  inner_classname: `flex ${imageLocation === 'left' ? 'flex--reverse' : ''} featured__flex`,
  content_classname: 'flex-item featured__content',
  figure_classname: `flex-item featured__figure featured__figure--${imageLocation}`,
  image_classname: 'featured__image',
  footer_classname: 'buttons buttons--mt',
  clickable_primary_classname: 'button--secondary',
  clickable_secondary_classname: 'link-button'
})

export const bslCountersBlockClasses: Fun<number, BSLCountersBlockStyle> = amountOfItems => ({
  block_classname: 'block block--counter',
  container_classname: `counters`,
  item_classname: 'counter-item',
  item_title_classname: 'title--m title--primary',
  item_subtitle_classname: 'title--xs'
})

export const iframeBlockClasses: Fun<number, IframeBlockStyle> = n => ({})

export const bslSuperGridBlockClasses: BSLSuperGridBlockStyle = {
  block_classname: 'block block--super-grid',
  title_classname: 'title--l title--mb2',
  item_subtitle_classname: 'title--xxs list-item__subtitle',
  list_classname: 'flex flex--2',
  item_classname: 'flex-item list-item list-item--border',
  item_title_classname: 'title--s list-item__title',
  item_title_text_classname: 'list-item__title-text',
  item_link_classname: 'list-item__link',
  item_wrapper_classname: 'list-item__wrapper',
  item_figure_classname: 'list-item__figure',
  item_image_classname: 'list-item__image',
  item_content_classname: 'list-item__content',
  item_download_classname: 'list-item__button button--download'
}

export const bslContactPersonBlockClasses: BSLContactPersonBlockStyle = {
  block_classname: 'block',
  inner_classname: 'contactperson__inner',
  content_classname: 'contactperson__content',
  title_classname: 'title--xs contactperson__title',
  subtitle_classname: 'contactperson__subtitle',
  function_classname: 'contactperson__function',
  name_classname: 'contactperson__name',
  figure_classname: 'contactperson__figure',
  image_classname: 'contactperson__image',
  buttons_classname: 'buttons',
  clickable_primary_classname: 'button--primary',
  clickable_secondary_classname: 'link link--with-icon'
}

export const bslTabsBlockClasses: BSLTabsBlockStyle = {
  block_classname: 'block',
  header_classname: 'tabs-block__header',
  title_classname: 'title--l',
  item_classname: 'tab-content',
  item_figure_classname: 'tab-content__figure',
  item_image_classname: 'tab-content__image',
  item_title_classname: 'title--m',
  item_description_classname: 'text--styled',
  item_content_classname: 'tab-content__text'
}

export const bslShowcaseBlockClasses: Fun<number, BSLShowcaseBlockStyle> = amountOfItems => ({
  block_classname: `block block--grey-left block--showcases block--showcases-${amountOfItems}`,
  titles_wrapper_classname: 'showcases__titles',
  subtitle_classname: 'title--m title--thin',
  title_classname: 'title--l title--mb2',
  footer_classname: 'showcases__footer',
  clickable_classname: 'button--secondary',
  item_large_classname: 'list-item list-item--large',
  item_normal_classname: 'list-item list-item--small list-item--border',
  item_link_classname: 'list-item__link',
  item_figure_classname: 'list-item__figure',
  item_image_classname: 'list-item__image',
  item_content_classname: 'list-item__content',
  item_title_large_classname: 'list-item__title title--m',
  item_title_normal_classname: 'list-item__title title--xs',
  item_title_text_classname: 'list-item__title-text',
  item_faux_link_classname: 'list-item__faux-link link-button'
})

export const bslLatestVacanciesBlockClasses: BSLLatestVacanciesBlockStyle = {
  title_classname: 'title--l',
  list_classname: 'flex flex--2',
  item_classname: 'flex-item list-item list-item--border',
  item_link_classname: 'list-item__link list-item__link--column',
  item_label_classname: 'list-item__label',
  item_title_classname: 'title--s list-item__title',
  item_title_text_classname: 'list-item__title-text',
  item_text_classname: 'list-item__text',
  clickable_primary_classname: 'button--secondary'
}

export const bslLatestEventsBlockClasses: BSLLatestEventsBlockStyle = {
  block_classname: 'block block--latest-events',
  title_classname: 'title--l',
  list_classname: 'flex flex--2',
  item_classname: 'flex-item list-item list-item--border',
  item_link_classname: 'list-item__link list-item__link--column',
  item_label_classname: 'list-item__label',
  item_title_classname: 'title--s list-item__title',
  item_title_text_classname: 'list-item__title-text',
  item_text_classname: 'list-item__text',
  clickable_primary_classname: 'button--secondary'
}

export const bslEventOverviewBlockClasses: BSLEventOverviewBlockStyle = {
  block_classname: 'block block--event-overview',
  list_classname: 'flex flex--2',
  item_classname: 'block__item flex-item list-item list-item--border',
  item_link_classname: 'block__link list-item__link list-item__link--column',
  item_label_classname: 'list-item__label',
  item_title_classname: 'title--xs list-item__title',
  item_title_text_classname: 'list-item__title-text',
  item_date_classname: 'block__date list-item__date',
  item_text_classname: 'list-item__text',
  item_icon_classname: 'list-item__text-icon fill--blue-700',
  clickable_primary_classname: 'button--secondary'
}

export const bslCaseSliderBlockClasses: BSLCaseSliderBlockStyle = {
  block_classname: 'block block--cases',
  inner_classname:'block__inner',
  content_classname:'block__content',
  list_classname: 'block__list',
  item_classname: 'block__case case',
  item_inner_classname: 'case__inner',
  item_image_classname: 'case__image lazyload',
  item_figure_classname: 'case__visual visual fit-object',
  item_placeholder_classname: 'case__placeholder',
  item_content_classname: 'case__content content',
  item_header_classname: 'case__header',
  item_label_classname: 'case__label',
  item_title_classname: 'title title--l case__title',
  item_intro_classname: 'case__intro intro text--styled',
  item_footer_classname: 'case__footer'
}

export const bslVacancySliderBlockClasses: BSLVacancySliderBlockStyle = {
  block_classname: 'block block--cases',
  inner_classname:'block__inner',
  content_classname:'block__content',
  list_classname: 'block__list',
  item_classname: 'block__case case',
  item_inner_classname: 'case__inner',
  item_image_classname: 'case__image lazyload',
  item_figure_classname: 'case__visual visual fit-object',
  item_placeholder_classname: 'case__placeholder',
  item_content_classname: 'case__content content',
  item_header_classname: 'case__header',
  item_label_classname: 'case__label',
  item_title_classname: 'title title--l case__title',
  item_intro_classname: 'case__intro intro text--styled',
  item_footer_classname: 'case__footer'
}

export const bslArticleHighlightBlockClasses: BSLArticleHighlightBlockStyle = {
  //TODO add classes
  block_classname: "block block--articles",
  inner_classname: 'block__inner',
  left_item_wrap_classname: "block__highlight",
  left_item_classname: "block__item item",
  left_item_content_classname: "item__content content",
  left_item_header_classname: "item__header",
  left_item_label_classname: "item__label",
  left_item_title_classname: "title title--l item__title",
  left_item_intro_classname: "item__intro text--styled",
  left_author_classname: "item__author author",
  left_author_info_classname: "author__wrap",
  left_author_name_classname: "author__name",
  left_author_function_classname: "author__function",
  left_author_visual_classname: "author__visual",
  left_author_image_classname: "author__image",
  left_item_footer_classname: "item__footer",
  left_item_link_classname: "item__link button--secondary",
  left_item_image_classname: "item__image",
  right_list_classname: "block__list block__articles",
  right_item_wrap_classname: "block__item item",
  right_item_classname: "item__inner",
  right_item_link_classname: "item__link link-block",
  right_item_content_classname: "item__content content",
  right_item_header_classname: "item__header",
  right_item_label_classname: "item__label",
  right_item_title_classname: "title title--xs item__title",
  right_item_visual_classname: "item__visual",
  right_item_image_classname: "item__image"
}

export const bslBeslismatrixFormBlockClasses: BSLBeslismatrixFormBlockStyle = {
  block_classname: 'block block--form',
  inner_classname: 'block__inner',
  header_classname: 'block__header',
  content_classname: 'block__content'
}
